// A working HQ page's heading: its title, and the line that used to sit under it — what the page is, that reading it is
// audited — as an info tip beside it, so the body starts with the work and not with a paragraph nobody reads.

import { InfoTip } from '@clavian/ui-web';
import type { ReactNode } from 'react';

export function HqHeading({ title, tip }: { readonly title: ReactNode; readonly tip?: ReactNode }): ReactNode {
  return (
    <div className="console-hq-heading">
      <h1 className="console-page__title">{title}</h1>
      {tip === undefined ? null : <InfoTip>{tip}</InfoTip>}
    </div>
  );
}
